<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <!-- <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-checkbox v-model="filters.pending" @change="handleCheck('pending')">{{ $t('pending_expenses_by_client') }}</vs-checkbox>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-checkbox v-model="filters.rejected" @change="handleCheck('rejected')">{{ $t('rejected_expenses_by_client') }}</vs-checkbox>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
           <vs-checkbox v-model="filters.invoiced" @change="handleCheck('invoiced')">{{ $t('invoiced_expenses_by_client') }}</vs-checkbox>
        </vs-col>
      </vs-row> -->

      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-w="4">
          <vs-radio color="#FF9F43" v-model="statusRadio" vs-value="pending">{{
            $t('pending_plural')
          }}</vs-radio>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="4">
          <vs-radio color="#BC1300" v-model="statusRadio" vs-value="rejected">{{
            $t('rejected_plural')
          }}</vs-radio>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="4">
          <vs-radio color="#2F48E6" v-model="statusRadio" vs-value="invoiced">{{
            $t('invoiced_plural')
          }}</vs-radio>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.client"
            multiple
            :options="clients"
            class="w-full"
            :reduce="client => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('vendor') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.vendor"
            multiple
            :autoscroll="false"
            :options="vendors"
            class="w-full"
            :reduce="vendor => vendor.id"
            label="name"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <input-date
            v-model="filters.date"
            :label="$t('date')"
            :onlyNewerYear="false"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('period') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.period"
            multiple
            :autoscroll="false"
            :options="periods"
            class="w-full"
            :reduce="period => period.PeriodId"
            label="YearWeek"
            name="filterWeek"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('currency') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.currencies"
            multiple
            :autoscroll="false"
            :options="currencies"
            class="w-full"
            name="filterCurrency"
          />
        </vs-col>
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="success" type="border" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'
import vSelect from 'vue-select'
import client from '@/http/requests/client'
import vendor from '@/http/requests/vendor'

export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate
  },
  props: {
    vendors: {
      type: Array,
      default: []
    },
    periods: {
      type: Array,
      default: []
    },
    clients: {
      type: Array,
      default: []
    },
    value: {
      type: Object,
      default: () => ({
        invoiced: false,
        pending: true,
        rejected: false,
        vendor: [],
        client: [],
        date: '',
        period: []
      })
    },
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    statusRadio() {
      this.filters.pending = false
      this.filters.rejected = false
      this.filters.invoiced = false
      switch (this.statusRadio) {
        case 'pending':
          this.filters.pending = true
          break
        case 'rejected':
          this.filters.rejected = true
          break
        default:
          this.filters.invoiced = true
          break
      }
    }
  },
  data() {
    return {
      name: 'accounting-filter',
      statusRadio: '',
      loading: {
        client: false,
        vendor: false,
        submit: false
      },
      filters: {
        invoiced: false,
        pending: false,
        rejected: false,
        vendor: [],
        client: [],
        date: '',
        period: [],
        currencies:[],
      },
      currencies:['MXN','USD']
    }
  },
  methods: {
    init() {
      this.filters = { ...this.value }
      if (this.filters.pending) {
        this.statusRadio = 'pending'
      }
      if (this.filters.rejected) {
        this.statusRadio = 'rejected'
      }
      if (this.filters.invoiced) {
        this.statusRadio = 'invoiced'
      }
    },
    clear() {
      (this.filters.pending = true),
      (this.filters.rejected = false),
      (this.filters.invoiced = false),
      (this.filters.vendor = [])
      this.filters.client = []
      this.filters.date = ''
      this.filters.period = []
      this.$emit('clear', this.filters)
      this.close()
    },
    setFilter() {
      this.$emit('input', this.filters)
      this.close()
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    handleCheck(check) {
      this.filters.invoiced = false
      this.filters.pending = false
      this.filters.rejected = false
      this.filters[check] = true
    }
  }
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}
</style>
